import React, { useState } from 'react';
import '../../../styles/venere-colors.css';
import { VenereBanner } from '../core/VenereBanner';
import VenereNavigation, { defaultVenereNavigationItems, NavigationItem } from '../core/VenereNavigation';

interface VenerePlatformLayoutProps {
  children: React.ReactNode;
  navigationItems?: NavigationItem[];
  className?: string;
}

export const VenerePlatformLayout: React.FC<VenerePlatformLayoutProps> = ({
  children,
  navigationItems = defaultVenereNavigationItems,
  className = '',
}) => {
  const [isNavCollapsed, setIsNavCollapsed] = useState(false);
  const [navbarWidth, setNavbarWidth] = useState(200); // Default width

  const handleNavbarWidthChange = (width: number) => {
    setNavbarWidth(width);
  };

  return (
    <div className="min-h-screen bg-white venere-content">
      {/* Fixed Top Banner - Desktop: Only covers main content area */}
      <div
        className="hidden lg:block fixed top-0 z-50 bg-white border-b border-gray-200 shadow-sm transition-all duration-300 ease-in-out"
        style={{
          left: isNavCollapsed ? '64px' : `${navbarWidth}px`,
          right: '0px'
        }}
      >
        <VenereBanner showUserAvatar={true} />
      </div>

      {/* Mobile Banner - Full width */}
      <div className="lg:hidden fixed top-0 left-0 right-0 z-50 bg-white border-b border-gray-200 shadow-sm">
        <VenereBanner showUserAvatar={true} />
      </div>

      {/* Navigation */}
      <VenereNavigation
        items={navigationItems}
        onCollapseChange={setIsNavCollapsed}
        onWidthChange={handleNavbarWidthChange}
      />

      {/* Main Content - Add top padding for fixed banner */}
      <main className={`${className} scrollbar-hide venere-content`} style={{ msOverflowStyle: 'none', scrollbarWidth: 'none' }}>
        {/* Mobile: Add top padding for banner and bottom padding for navigation */}
        <div className="lg:hidden pt-16 pb-20 scrollbar-hide venere-content" style={{ msOverflowStyle: 'none', scrollbarWidth: 'none' }}>
          {children}
        </div>

        {/* Desktop: Add left margin for sidebar */}
        <div
          className="hidden lg:block transition-all duration-300 ease-in-out scrollbar-hide venere-content"
          style={{
            msOverflowStyle: 'none',
            scrollbarWidth: 'none',
            marginLeft: isNavCollapsed ? '64px' : `${navbarWidth}px`,
            paddingTop: '4rem' // Add top padding for banner
          }}
        >
          {children}
        </div>
      </main>
    </div>
  );
};

export default VenerePlatformLayout; 